import { useInView } from "react-intersection-observer";
import LazyImage from "../LazyImage";

export const ImgAndCopy = ({ heading, copy, image, className }) => {
  const [slideUpRef, isInView] = useInView({ triggerOnce: true });

  return (
    <div
      className={`tw-flex tw-flex-col tw-gap-8 tw-items-center tw-text-center ${
        isInView ? "slide-up" : ""
      } ${className}`}
      ref={slideUpRef}
    >
      <div className="tw-flex tw-flex-col tw-gap-2">
        {heading && <h2 className="heading2">{heading}</h2>}
        {copy && <div dangerouslySetInnerHTML={{ __html: copy }} />}
      </div>
      {image && (
        <div className="tw-rounded-xl tw-overflow-clip">
          <LazyImage
            src={image.url}
            alt={image.alt || image.title || "Quell"}
          />
        </div>
      )}
    </div>
  );
};
